module.exports = "/images/med-dream-logo.svg?69ee00f02984ebaae037c1dfe2728bc4";